import React from 'react'
import './featureSection.css'

function FeatureSection() {
    return (
        <div className="featureSection" id="Features">
            <div className="features">
            <div className="feature f5">
                    <img src="https://global-uploads.webflow.com/5da0478a951135b39339e016/60b6ba3aca1a1ab153a9c522_icon-5.svg" />
                    <div className="feature">
                        <h2>Targeted Learning</h2>
                        <p>You don’t need to practice thousands of questions. My program focuses on a carefully curated set of 150 DSA questions that build a strong foundation and help you master problem-solving techniques. These questions cover a wide range of topics, including Arrays, Trees, Dynamic Programming, Graphs, and more.</p>
                    </div>
                </div>

                <div className="f1">
                    <img src="https://global-uploads.webflow.com/5da0478a951135b39339e016/60b6ba3a1fdcf05fc727e174_icon-1.svg" />
                    <div className="feature">
                        <h2>Learn from a Proven Expert</h2>
                        <p>As someone who has qualified for global-level DSA competitions and works at Meta, I know what top tech companies look for in candidates. This program is designed based on real interview experiences and industry requirements.</p>
                    </div>
                </div>

                <div className="feature f2">
                    <img src="https://global-uploads.webflow.com/5da0478a951135b39339e016/60b6ba398f46bc168e13241e_icon-2.svg" />
                    <div className="feature">
                        <h2>Affordable & Accessible</h2>
                        <p>For a limited time, get access to this invaluable resource for only 2 rupees per question! That’s right—just ₹2 per question for high-quality learning material that can fast-track your journey to a successful career in tech.</p>
                    </div>
                </div>

                <div className="feature f3">
                    <img src="	https://global-uploads.webflow.com/5da0478a951135b39339e016/60b6ba3b9d3bc0d9287c565f_icon-3.svg" />
                    <div className="feature">
                        <h2>Perfect for Busy Professionals and Students</h2>
                        <p>Whether you’re a working professional looking to switch jobs or a student preparing for your first big interview, this program is structured to help you learn efficiently. No need to waste time on unnecessary questions—focus on what matters most.</p>
                    </div>
                </div>

                <div className="feature f4">
                    <img src="	https://global-uploads.webflow.com/5da0478a951135b39339e016/60b6ba3ab8cec0d7f580382a_icon-4.svg" />
                    <div className="feature">
                        <h2>Proven Success Record</h2>
                        <p>This program has already helped many candidates secure roles at top tech companies. With testimonials from successful professionals who’ve used these questions to land their dream jobs, you’ll have the confidence that this program is a tried-and-tested path to interview success.</p>
                    </div>
                </div>

                

                <div className="f6">
                    <img src="https://global-uploads.webflow.com/5da0478a951135b39339e016/60b6ba3aea7d011921d97c1e_icon-6.svg" />
                    <div className="feature">
                        <h2>Real-World Interview Insights</h2>
                        <p>Each question is selected based on real-world interview trends and patterns, focusing on situations you're likely to encounter in interviews. By studying this tailored set, you'll be better prepared to think like an expert and tackle problems strategically.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeatureSection;
